import React from 'react';

/**
 * Icon Button for expand/collapse menus
 *
 * @param active
 * @param open
 * @return {JSX.Element}
 * @constructor
 */
const ExpandIconButton = ({active = false, open = false}) => {

    let activeClass = (active) ? ' active' : '';
    let openClass = (open) ? ' open' : '';

    return (
        <span className={`button-expand${activeClass}${openClass}`}>
        </span>
    )
};

export default ExpandIconButton;
